import { sitesApi } from '@/lib/api/sites';

export function suggestedSiteName(filename) {
  const name = String(filename || '').split(/[/\\]/).pop().replace(/\.html?$/i, '')
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40).replace(/-$/, '');
  return !siteNameError(name) && !['index', 'main', 'app'].includes(name) ? name : 'my-creation';
}

export function siteNameError(name) {
  if (name.length < 3 || name.length > 40) return 'Choose a name with 3–40 characters.';
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name) || !/[a-z]/.test(name)) {
    return 'Use letters, numbers, and single hyphens. Include at least one letter.';
  }
  if (name.startsWith('xn-')) return 'Names can’t start with “xn-”.';
  return null;
}

// Shared by inline cards and artifact viewers. Publication never starts a
// model turn or resumes the task; the server reads the selected saved artifact.
const submitting = new Set();
export async function requestSitePublication({ taskId, name, file, artifact, prepareFile, replaceExisting = false }) {
  const fileId = file?.id || file?._id || artifact?.fileId;
  const artifactPath = artifact?.path || file?.parameters?.workArtifactPath;
  if (!fileId && !(taskId && artifactPath) && !prepareFile) throw new Error('Open or save this HTML creation to publish it.');
  const validation = siteNameError(name);
  if (validation) throw new Error(validation);
  const key = fileId ? `file:${fileId}` : taskId ? `task:${taskId}` : prepareFile;
  if (submitting.has(key)) throw new Error('This creation is already being published. Please wait.');
  submitting.add(key);
  try {
    const prepared = !fileId && prepareFile ? await prepareFile() : file;
    const savedId = prepared?.id || prepared?._id || fileId;
    if (!savedId && !(taskId && artifactPath)) throw new Error('This creation could not be saved. Please try again.');
    const out = await sitesApi.publish({ ...(taskId ? { taskId } : {}), name, ...(savedId ? { fileId: String(savedId) } : { artifactPath }), replaceExisting });
    if (out?.site?.name !== name || out.site.status !== 'live' || !out.site.url) throw new Error('Publication has not been confirmed. Check My sites before trying again.');
    return out;
  } finally {
    submitting.delete(key);
  }
}
